module.exports = __webpack_public_path__ + "media/images/a8-696891fcbcc17c4fc61fe5c1a9812f98.jpg";